import { render, staticRenderFns } from "./ChallengeQuestion.vue?vue&type=template&id=10fd874c"
import script from "./ChallengeQuestion.vue?vue&type=script&lang=js"
export * from "./ChallengeQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports